<div class="rx-treatment-table">
	<mat-table [dataSource]="displayedRows$" multiTemplateDataRows>
		<!-- Tooth No. column -->
		<ng-container matColumnDef="toothNumberLabel">
			<mat-header-cell *matHeaderCellDef class="rx-treatment-table__header-cell">
				{{ 'TreatmentInformation.ToothNo' | translate }}
			</mat-header-cell>
			<mat-cell
				*matCellDef="let row"
				class="rx-treatment-table__cell"
				[class.rx-treatment-table__cell--bridge-header]="row.isBridgeHeader"
				[attr.role]="row.isBridgeHeader ? 'button' : null"
				[attr.tabindex]="row.isBridgeHeader ? 0 : null"
				(click)="row.isBridgeHeader && onBridgeHeaderClick(row)"
				(keydown.enter)="row.isBridgeHeader && onBridgeHeaderClick(row)"
			>
				{{ row.toothNumberLabel }}
				<tlk-chevron-down-icon *ngIf="row.isBridgeHeader && !row.isCollapsed" class="rx-treatment-table__chevron" />
				<tlk-chevron-right-icon *ngIf="row.isBridgeHeader && row.isCollapsed" class="rx-treatment-table__chevron" />
			</mat-cell>
		</ng-container>

		<!-- Treatment column -->
		<ng-container matColumnDef="treatment">
			<mat-header-cell *matHeaderCellDef class="rx-treatment-table__header-cell">
				{{ 'TreatmentInformation.Treatment' | translate }}
			</mat-header-cell>
			<mat-cell *matCellDef="let row" class="rx-treatment-table__cell">
				{{ row.treatment }}
			</mat-cell>
		</ng-container>

		<!-- Specification column -->
		<ng-container matColumnDef="specification">
			<mat-header-cell *matHeaderCellDef class="rx-treatment-table__header-cell">
				{{ 'TreatmentInformation.Specification' | translate }}
			</mat-header-cell>
			<mat-cell *matCellDef="let row" class="rx-treatment-table__cell">
				{{ row.specification }}
			</mat-cell>
		</ng-container>

		<!-- Material column -->
		<ng-container matColumnDef="material">
			<mat-header-cell *matHeaderCellDef class="rx-treatment-table__header-cell">
				{{ 'TreatmentInformation.Material' | translate }}
			</mat-header-cell>
			<mat-cell *matCellDef="let row" class="rx-treatment-table__cell">
				{{ row.material }}
			</mat-cell>
		</ng-container>

		<!-- Shade Body column -->
		<ng-container matColumnDef="shadeBody">
			<mat-header-cell *matHeaderCellDef class="rx-treatment-table__header-cell">
				{{ 'TreatmentInformation.ShadeBody' | translate }}
			</mat-header-cell>
			<mat-cell *matCellDef="let row" class="rx-treatment-table__cell">
				{{ row.shadeBody }}
			</mat-cell>
		</ng-container>

		<!-- Pontic configuration label column -->
		<ng-container matColumnDef="ponticLabel">
			<mat-cell *matCellDef="let row" class="rx-treatment-table__cell rx-treatment-table__cell--pontic-label">
				{{ 'Pontic Design' | translate }}
			</mat-cell>
		</ng-container>

		<!-- Pontic configuration selector column -->
		<ng-container matColumnDef="pontic">
			<mat-cell *matCellDef="let row" class="rx-treatment-table__cell rx-treatment-table__cell--pontic-selector">
				<rx-pontic-selector
					[selectedValue]="row.ponticDesignId | mapper : getDesignById.bind(this) : ponticDesigns"
					[name]="'pontic-' + row.bridgeIndex"
					[isReadonly]="true"
					[options]="ponticDesigns"
					[showLabel]="false"
					class="rx-treatment-table__pontic-selector"
				></rx-pontic-selector>
			</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

		<!-- Standard data row -->
		<mat-row
			*matRowDef="let row; columns: displayedColumns"
		></mat-row>

		<!-- Pontic configuration row — rendered after the last tooth row of a bridge that has a pontic design -->
		<mat-row
			*matRowDef="let row; columns: ['ponticLabel', 'pontic']; when: hasPonticDesignRow"
			class="rx-treatment-table__row--pontic-design"
		></mat-row>
	</mat-table>
</div>
